/**
 * V210 (hotfix del aviso público) — helpers puros del aviso del tenant. El aviso publicado
 * es SIEMPRE el documento propio del tenant; FluidSol nunca publica una plantilla (las
 * plantillas son documentos para completar — decisión de Arturo 08/10).
 */
import { TENANT_TEMPLATES_V32, templateV32Path } from '../legal/legalConfig';

export type AvisoDocumentKind = 'pdf' | 'docx' | 'other';

/** Etiqueta de versión REAL del aviso publicado: archivo + fecha de carga + hash corto.
 *  Sin prefijo "v" (antes el panel anteponía "v" a "aviso-plantilla-v1.0" → "vaviso…"). */
export function avisoVersionLabel(fileName: string, uploadedAt: string | null, shortHash: string): string {
  const date = uploadedAt ? new Date(uploadedAt).toLocaleDateString('es-MX') : null;
  return [fileName, date ? `cargado el ${date}` : null, shortHash ? `huella ${shortHash.slice(0, 8)}` : null]
    .filter(Boolean)
    .join(' · ');
}

export interface AvisoCovers { facturacion: boolean; reservasPagos: boolean; fidelidad: boolean }

/** La plantilla de la combinación EXACTA de finalidades (v1.1 donde existe; v1.0 en
 *  facturación sola, reservas sola y facturación + reservas). Solo para DESCARGA. */
export function templateForCovers(c: AvisoCovers): { title: string; href: string; templateVersion: string } | null {
  if (!c.facturacion && !c.reservasPagos && !c.fidelidad) return null;
  const t = TENANT_TEMPLATES_V32.find((x) => x.covers.facturacion === c.facturacion
    && x.covers.reservasPagos === c.reservasPagos && x.covers.fidelidad === c.fidelidad);
  if (!t) return null;
  return {
    title: t.title,
    href: templateV32Path(t.file, 'docx', t.version),
    templateVersion: t.version === '3.3' ? 'v1.1' : 'v1.0',
  };
}
